/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".textarea-append[_ngcontent-%COMP%]{background:#e9ecef;width:100%;border:1px solid #dde2ec;display:flex;align-items:center;padding:5px 10px;justify-content:space-between}.textarea-append[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:12px;text-transform:uppercase;font-weight:700}.textarea-append[_ngcontent-%COMP%]   .badge-default[_ngcontent-%COMP%]{background:#d0d0d0}.price-label[_ngcontent-%COMP%]{color:var(--text-color);font-size:.9rem;font-weight:600}.mat-input-element[_ngcontent-%COMP%]{padding:.375rem .75rem}"];
export { styles as styles };
